const PROVIDER_NOT_SHARED_MESSAGE =
  "Provider is not shared with this business unit";

/**
 * The API rejects a reveal when the provider has no live sharing with the
 * business unit (they never shared, or stopped sharing after the page loaded).
 * That is a state the user can only see and accept, not a failure to report.
 */
export function isProviderNotSharedError(error: unknown): boolean {
  return (
    typeof error === "object" &&
    error !== null &&
    (error as { message?: unknown }).message === PROVIDER_NOT_SHARED_MESSAGE
  );
}
